<div class="client-details-page">
  <div class="card card-custom client-details-shell details-page-shell">
    <div class="card-body">
        <div class="details_top">
          <div class="details-page-heading">
            <div class="details-page-heading__primary">
              <span class="details-page-heading__eyebrow">{{ 'CLIENT_DETAILS' | translate }}</span>
            </div>
            <div class="details-page-heading__actions" *ngIf="isAdmin || doWhat.canWrite || doWhat.canDelete">
              <button *ngIf="isAdmin || doWhat.canWrite" type="button" class="orange-button" (click)="onEditClientDetails()">{{ 'EDIT_CLIENT' | translate }}</button>
              <button *ngIf="isAdmin || doWhat.canDelete" type="button" class="red-button" (click)="onDeleteClientDetails()">{{ 'DELETE' | translate }}</button>
            </div>
          </div>
          <h1 class="details-heading">
            <ng-container *ngIf="instance.isAltLayout; else defaultName">{{ clientData?.lastName }}</ng-container>
            <ng-template #defaultName>{{clientData?.firstName}} {{clientData?.lastName}}</ng-template>
          </h1>
          <h3 class="details-subheading">{{clientData?.brand}}</h3>
          <div class="row row-gap-4 d-flex align-items-stretch details-summary-grid">
            <div class="col-12" *ngIf="isTiered && !instance.isAltLayout">
              <div class="tier-banner details-tier-banner" [ngClass]="tierBannerClass" role="status">
                  <h3 class="tier-banner__title details-tier-title">{{ tierName | P_TierName }}</h3>
              </div>
            </div>
            <div class="col-12 " [ngClass]="(isExternal) ? 'col-xl-6' : 'col-xl-6'">
              <div class="card details-card">
                <h5 class="card-title">{{ 'CONTACT_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p><strong>{{ 'EMAIL' | translate }}:</strong> {{clientData?.email}}<button *ngIf="clientData.email && !isExternal && !instance.isAltLayout" type="button" class="details-inline-link" (click)="openSendEmailModal()" [attr.aria-label]="'SEND_EMAIL' | translate"><i-feather name="mail" class="details-inline-icon"></i-feather></button> <a *ngIf="clientData.email" class="details-inline-link" href="mailto:{{ clientData.email }}"><i-feather name="external-link" class="details-inline-icon"></i-feather></a></p>
                  <p><strong>{{ 'PHONE' | translate }}:</strong> {{clientData?.phone}}</p>
                  <p><strong>{{ 'ADDRESS' | translate }}:</strong><br *ngIf="clientData?.brandAddress" />
                    {{clientData?.brandAddress}}</p>
                    
                  <p *ngIf="((isClientOwner || isAdmin) && tierName == 'Basic Tier' && !instance.isAltLayout)"><button class="btn red-button" (click)="openCreateTaskExternalModal()">{{ 'SEND_REQUEST' | translate }}</button></p>
                </div>
              </div>
            </div>
            <div class="col-12 " [ngClass]="(isExternal) ? 'col-xl-6' : 'col-xl-6'">
              <div class="card details-card">
                <h5 class="card-title">{{ 'ADDITIONAL_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p *ngIf="!isExternal || tierName !== 'Basic Tier' || !instance.isAltLayout"><strong>{{ 'DMS' | translate }}:</strong> {{ clientData?.dmsName }}</p>
                  <p *ngIf="!instance.isAltLayout"><strong>{{ 'SALES_REP' | translate }}:</strong> {{ clientData?.salesRep }}</p>
                  <p *ngIf="clientData?.emailForInvoice && !instance.isAltLayout"><strong>{{ 'INVOICE_EMAIL' | translate }}:</strong> {{ clientData?.emailForInvoice }}</p>
                  <p *ngIf="!isExternal"><strong>{{ 'OWNER_USER_RECORD' | translate }}:</strong> {{clientData?.clientOwner}}</p>
                  <p class="employee-users"><strong>{{ 'EMPLOYEE_USERS' | translate }}:</strong><br *ngIf="clientData?.employees?.length !== 0" />
                    <span *ngFor="let e of clientData.employees; let last = last">
                      <ng-container *ngIf="instance.isLastNameFirst; else firstLast">
                        {{ e?.lastName }} {{ e?.firstName }}<ng-container *ngIf="!last">, </ng-container>
                      </ng-container>
                      <ng-template #firstLast>
                        {{ e?.firstName }} {{ e?.lastName }}<ng-container *ngIf="!last">, </ng-container>
                      </ng-template>
                    </span>
                  </p>

                  <p *ngIf="!isExternal">
                    <button class="btn blue-button m-2 ms-0" (click)="openChangeDmsModal()">{{ 'CHANGE_DMS' | translate }}</button>
                    <button *ngIf="!instance.isAltLayout" class="btn blue-button m-2 ms-0" (click)="openTechRequestModal()">{{ 'TECH_REQUEST' | translate }}</button>
                    <button *ngIf="!instance.isAltLayout" class="btn blue-button m-2 ms-0" (click)="openCreativeRequestModal()">{{ 'COPY_CREATIVE_REQUEST' | translate }}</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dv-custom-navs">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="onActiveTabChange($event)" class="nav-tabs details-nav-tabs">
              <li [ngbNavItem]="1" *ngIf="isTabVisible(1)" [class.rm-tab-active]="active === 1">
                <a ngbNavLink>
                  <i-feather name="paperclip"></i-feather><label>{{ 'NOTES' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--notes">
                      <app-notes [iIsAdmin]="isAdmin" [iIsExternal]="isExternal"
                        [iCanDelete]="isAdmin || roleOptions.notes.canDelete"
                        [iCanWrite]="isAdmin || roleOptions.notes.canWrite" [iParentId]="clientData.id" [iType]="2">
                      </app-notes>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" *ngIf="isTabVisible(2)" [class.rm-tab-active]="active === 2">
                <a ngbNavLink>
                  <i-feather name="edit"></i-feather><label>{{ 'CAMPAIGNS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                      <app-campaign-datatable [iCanRead]="isAdmin || (roleOptions.campaigns && roleOptions.campaigns.canRead)"
                        [iCanWrite]="isAdmin || (roleOptions.campaigns && roleOptions.campaigns.canWrite)"
                        [iCanDelete]="isAdmin || (roleOptions.campaigns && roleOptions.campaigns.canDelete)"
                        [iColumns]="columnsCampaign" [iShowActions]="false"
                        [iData$]="campaignsData" [iRowLinkHandler]="getCampaignRowLink" [iShowSelect]="false">
                      </app-campaign-datatable>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="3" *ngIf="isTabVisible(3)" [class.rm-tab-active]="active === 3">
                <a ngbNavLink>
                  <i-feather name="list"></i-feather><label>{{ 'TASKS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface">
                      <div class="details-tab-toolbar">
                        <div fxLayout="row" fxLayoutAlign="start center" class="details-tab-toolbar__controls">
                          <button type="button" class="gray-button gray-button--toggle details-task-filter-button">
                            <label class="gray-button__toggle-content" for="showMyTasksCheckbox">
                                <input type="checkbox" id="showMyTasksCheckbox" [(ngModel)]="showOnlyMyTasks" (change)="onShowMyTasksChange()" [value]="('SHOW_ONLY_MY_TASKS' | translate)">
                                {{ 'SHOW_ONLY_MY_TASKS' | translate }}
                            </label>
                          </button>
                        </div>
                        <div class="details-tab-toolbar__actions">
                          <button class="blue-button" type="button" (click)="onAddTask()">{{ 'ADD_TASK' | translate }}</button>
                        </div>
                      </div>
                      <div fxLayout="row" fxLayoutAlign="space-between center" class="details-task-filters">
                        <div fxLayout="row" fxLayoutAlign="start center" class="details-task-toggle-group">
                          <div (click)="changeShowTasks()" class="details-task-toggle-shell">
                            <h2 class="details-task-toggle" [class.is-active]="showTasks">{{ 'TO_DO' | translate }}</h2>
                          </div>
                          <div (click)="changeShowCompletedTasks()" class="details-task-toggle-shell">
                            <h2 class="details-task-toggle" [class.is-active]="showCompletedTasks">{{ 'COMPLETED' | translate }}</h2>
                          </div>
                        </div>
                      </div>
                      <app-tasks-datatable *ngIf="showTasks" 
                        [iCanRead]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canRead)"
                        [iCanWrite]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canWrite)"
                        [iCanDelete]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canDelete)"
                        (oRowClick)="onTaskRowClick($event)" 
                        [iSortColumn]="'title'" 
                        [iColumns]="columnsTasks"
                        [iHideHeaderActions]="true"
                        [iShowActions]="false" 
                        [iShowExport]="false"
                        [iShowSelect]="false"
                        [iData$]="tasksData">
                      </app-tasks-datatable>
                      <app-tasks-datatable *ngIf="showCompletedTasks" 
                        [iCanRead]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canRead)"
                        [iCanWrite]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canWrite)"
                        [iCanDelete]="isAdmin || (roleOptions.tasks && roleOptions.tasks.canDelete)"
                        (oRowClick)="onTaskRowClick($event)" 
                        [iSortColumn]="'completedOn'" 
                        [iSortDirection]="'desc'"
                        [iColumns]="completedTasksColumns" 
                        [iHideHeaderActions]="true"
                        [iShowActions]="false" 
                        [iShowExport]="false"
                        [iShowSelect]="false"
                        [iData$]="completedTasksData" [isCompleted]="true">
                      </app-tasks-datatable>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="4" *ngIf="isTabVisible(4)" [class.rm-tab-active]="active === 4">
                <a ngbNavLink>
                  <i-feather name="tag"></i-feather><label>{{ 'TAGS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--notes">
                      <app-tags-tab [iCanWrite]="isAdmin || (roleOptions.tags && roleOptions.tags.canWrite)"
                        [iParentId]="clientData.id" [iType]="2"></app-tags-tab>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="5" *ngIf="isTabVisible(5)" [class.rm-tab-active]="active === 5">
                <a ngbNavLink>
                  <i-feather name="refresh-cw"></i-feather><label>{{ 'SUBSCRIPTIONS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                      <app-subscription-shared [iClientId]="clientData.id">
                      </app-subscription-shared>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="6" *ngIf="isTabVisible(6)" [class.rm-tab-active]="active === 6">
                <a ngbNavLink>
                  <i-feather name="dollar-sign"></i-feather><label>{{ 'ORDERS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                      <app-campaign-datatable
                        iSortColumn="numericId"
                        iSortDirection="desc"
                        [iCanRead]="ordersPermissions.canRead"
                        [iColumns]="orderColumns"
                        [iData$]="checkingOrders"
                        [iHideHeaderActions]="false"
                        [iRowLinkHandler]="getOrderRowLink"
                        [iShowActions]="false"
                        [iShowEditAction]="false"
                        [iShowExport]="false"
                        [iShowSelect]="false"
                        [iShowViewAction]="true"
                        [iTotalCount]="checkingOrders.length">
                      </app-campaign-datatable>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="7" *ngIf="isTabVisible(7)" [class.rm-tab-active]="active === 7">
                <a ngbNavLink>
                  <i-feather name="file-text"></i-feather><label>{{ 'EMAIL_REPORTS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                      <div class="details-tab-toolbar details-tab-toolbar--spaced">
                        <div></div>
                        <div class="details-tab-toolbar__actions">
                          <button *ngIf="isAdmin || (roleOptions.reports && roleOptions.reports.canWrite)" class="blue-button"
                          type="button" (click)="addNewReportingConfig()">{{ 'ADD_REPORTING' | translate }}</button>
                        </div>
                      </div>
                      <app-datatable [iCanRead]="isAdmin || (roleOptions.reports && roleOptions.reports.canRead)"
                        [iCanWrite]="isAdmin || (roleOptions.reports && roleOptions.reports.canEdit)"
                        [iCanDelete]="isAdmin || (roleOptions.reports && roleOptions.reports.canDelete)"
                        [iColumns]="reportingConfigTableColumns" [iData$]="reportingConfigTableData" 
                        iSortColumn="campaigns" [iShowActions]="true"
                        [iShowExport]="false" (oAddNew)="addNewReportingConfig()" (oEditRow)="editReportingConfigRow($event)"
                        (oDeleteRows)="deleteReportingConfigRows($event)">
                      </app-datatable>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="8" *ngIf="isTabVisible(8)" [class.rm-tab-active]="active === 8">
                <a ngbNavLink>
                  <i-feather name="bar-chart-2"></i-feather><label>{{ 'LEADS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--tight">
                      <app-campaign-datatable [iCanRead]="leadsPermissions.canRead" [iCanWrite]="leadsPermissions.canWrite" [iCanDelete]="leadsPermissions.canDelete"
                          [iColumns]="leadsColumns" (oDeleteRows)="onDelete($event)" [iRowLinkHandler]="getRowLink"
                          [iTotalCount]="leadsTotalCount" [iShowEditAction]="false"
                          [iData$]="leadsData" [iShowSelect]="false"
                          iSortColumn="createdAt" iSortDirection="desc" [iShowSelect]="true">
                      </app-campaign-datatable>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="9" *ngIf="isTabVisible(9)" [class.rm-tab-active]="active === 9">
                <a ngbNavLink>
                  <i-feather name="layout"></i-feather><label>{{ 'REPORTS' | translate }}</label>
                </a>
                <ng-template ngbNavContent>
                  <div class="details-tab-panel">
                    <div class="details-tab-panel__surface details-tab-surface details-tab-surface--report">
                      <div class="campaignSelect">
                        <label for="campaignSelector">{{ 'SELECT_CAMPAIGN' | translate }}:</label>
                        <select id="campaignSelector" class="form-select" [(ngModel)]="selectedCampaignId" (ngModelChange)="updateReportView($event)">
                          <option value="">{{ 'SELECT_PLACEHOLDER' | translate }}</option>
                          <option *ngFor="let campaign of campaignsData" [value]="campaign.id">{{ campaign.name }}</option>
                        </select>
                      </div>
                      <app-report-view *ngIf="selectedCampaignId" [Iid]="selectedCampaignId"></app-report-view>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div class="details-nav-outlet" [ngbNavOutlet]="nav"></div>
        </div>
    </div>
  </div>
</div>
